<template>
    <div class="yy-container">
        <el-form ref="message">
            <el-form-item>
                <!-- 头部 -->
                <el-select v-model="messageGroup" @change="changOption" class="w200">
                    <el-option v-for="item in messageOptions" :key="item.messageType" :label="item.messageTypeWithCluture" :value="item.messageType"></el-option>
                </el-select>
                <el-button type="primary" v-if="messageGroup >= 0 && !isNaN(parseInt(messageGroup))" @click="handleConfirm" :disabled="messageList.length == 0 ? true : false">清空</el-button>
            </el-form-item>
        </el-form>
        <div class="table-wrapper">
            <el-table :data="messageList" empty-text="暫無數據" v-loading="loading" :row-style="changeBg" @row-click="clickRow">
                <el-table-column :width="13 * 12" label="分類" prop="messageTypeWithCluture"></el-table-column>
                <el-table-column :width="13 * 8" label="操作人" prop="createUser"></el-table-column>
                <el-table-column :width="19 * 13" label="操作時間">
                    <template v-slot="scope">{{ scope.row.createTime | dateFilter }}</template>
                </el-table-column>
                <el-table-column label="詳情">
                    <template slot-scope="{ row }" v-if="row.messageContent">
                        <!-- 樓盤相關 row.messageType == 0 &&row.sourceType == 'PropertyExpired '-->
                        <div v-if="row.messageType == 0">
                            {{ row.messageContent }}
                            <span v-if="isToDateFilter(row.messageContent)">，</span>
                            <a target="_blank" v-if="isToDateFilter(row.messageContent) && (row.sourceType == 'PropertyExpired' || row.sourceType == 'WillPropertyExpire') " @click="toPropertyList(row.messageContent,row.sourceID)">立即去續期</a>
                            <a target="_blank" v-if="(row.sourceType == 'RemindRecommMany') || (row.sourceType == 'RemindRecommManySingle') " @click="toPropertyList(row.messageContent,row.sourceID)">點擊推前</a>
                        </div>
                        <!-- 賬戶變動 -->
                        <div v-else-if="row.messageType == 1">{{ row.messageContent }}</div>
                        <!-- 客戶留言 -->
                        <div v-else-if="row.messageType == 2">
                            {{ row.messageContent }}
                            <span>，</span>
                            <a target="_blank" @click="toDetail(row.sourceID)">點擊查看詳情</a>
                        </div>
                        <!-- House730官方通知 -->
                        <div v-else-if="row.messageType == 3">
                            {{ row.sysMessageTypeWithCluture }} {{ row.messageTitle }} {{ row.messageContent }}
                            <a style="margin-left: 10px" v-if="row.messageUrl || row.estateID > 0" target="_blank" @click="toHouse(row)">點擊查看</a>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                            <span>-</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-footer>
                <!-- 底部分页 -->
                <div class="yy-record">
                    <el-pagination @current-change="handleCurrent" @size-change="handlePageSizeChange" background :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="params.pageCount" layout="total,sizes, prev, pager, next, jumper" :total="messageCount"></el-pagination>
                </div>
            </el-footer>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: 'messageManage',
    data() {
        return {
            messageOptions: [],
            messageGroup: '',
            messageCount: 0,
            currentPage: 1,
            messageList: [],
            loading: false,
            params: {
                messageType: '',
                pageIndex: 1,
                pageCount: 10
            }
        };
    },
    filters: {
        dateFilter(timestamp) {
            var time = timestamp * 1000;
            var date = new Date(time + 8 * 3600 * 1000); // 增加8小时
            return date.toJSON().substr(0, 19).replace('T', ' ');
        }
    },
    components: {},
    computed: {
        ...mapGetters(['userInfo'])
    },
    created() {
        this.$nextTick(() => {
            this.params.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'noticePageCount') || 10;
            this.getOptions();
            this.getAllMessages();
        });
    },
    methods: {
        toHouse(row) {
            if (row.estateID > 0) {
                const license = this.userInfo.accountID ? 'A' + this.userInfo.accountID : 'none';
                window.open(`${this.pub.config.wapUrl}new-property-${row.estateID}.html?license=${license}`, '_blank');
            } else if (row.messageUrl) {
                var url = row.messageUrl;
                if (row.messageUrl.indexOf('http') == -1) {
                    url = '//' + url;
                }
                window.open(url, '_blank');
            }
        },
        getAllMessages() {
            this.loading = true;
            this.axios.post(this.pub.getApi().SearchMessageCenter, this.params).then(res => {
                if (res.data.code === 0) {
                    this.loading = false;
                    this.messageList = res.data.result.data;
                    this.messageCount = res.data.result.count;
                }
            });
        },
        getOptions() {
            this.axios.get(this.pub.getApi().GetUserMessage).then(res => {
                if (res.data.code === 0) {
                    this.messageOptions = res.data.result;
                }
            });
        },
        changOption() {
            this.currentPage = 1;
            this.params.pageIndex = this.currentPage;
            this.params.messageType = this.messageGroup.toString();
            this.getAllMessages();
        },
        handleConfirm() {
            this.$confirm('確認刪除該分類下所有消息?', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.clearMessage();
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刪除',
                        showClose: true
                    });
                });
        },
        changeBg({ row, rowIndex }) {
            if (row.isRead) {
                return {
                    background: '#eeeff3'
                };
            }
        },
        clickRow(row) {
            if (row.isRead) {
                return false;
            }
            const params = row.messageType == 3 ? { setSystemMessageReadList: [row.systemMessageID] } : { setReadList: [row.messageID] };
            this.axios.post(this.pub.getApi().UpdateMessageStatus, params).then(res => {
                if (res.data.code == 0 && res.data.result) {
                    row.isRead = true;
                }
            });
        },
        async clearMessage() {
            this.loading = true;
            // this.getotalTypeMessage().then(res => {
            //     var targets = res;
            //     if (targets.length) {
            const params = {
                setDeleteType: this.messageGroup
            };

            this.axios.post(this.pub.getApi().UpdateMessageStatus, params).then(res1 => {
                this.loading = false;
                this.$message({
                    type: 'success',
                    message: '删除成功',
                    showClose: true
                });
                this.params.pageIndex = 1;
                this.getAllMessages();
            });
            // }
            // });
        },
        async getotalTypeMessage() {
            this.params.messageType = this.messageGroup.toString();
            const messageInfo = await this.axios.post(this.pub.getApi().SearchMessageCenter, this.params);
            if (messageInfo.data.code == 0 && messageInfo.data.result) {
                var messages = messageInfo.data.result.data;
                var totalTypeCount = messageInfo.data.result.count;
            }
            while (messages.length < totalTypeCount) {
                this.params.pageIndex++;
                const messageInfo = await this.axios.post(this.pub.getApi().SearchMessageCenter, this.params);
                if (messageInfo.data.code == 0 && messageInfo.data.result) {
                    messages = messages.concat(messageInfo.data.result.data);
                }
            }
            return messages;
        },
        handleCurrent(index) {
            this.currentPage = index;
            this.params.pageIndex = this.currentPage;
            this.getAllMessages();
        },
        handlePageSizeChange(val) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID,'noticePageCount',val)
            this.params.pageCount = val;
            this.getAllMessages();
        },
        toDetail(sourceID) {
            this.axios.get(this.pub.getApi().GetProperty + `?propertyId=${sourceID}`).then(res => {
                if (res.data.code == 0 && res.data.result) {
                    //   var property = res.data.result;
                    //   if (property.rentalType == 1) {
                    //     // 售
                    //     window.open(`${this.pub.config.pcUrl}buy-property-${sourceID}.html`,'_blank')
                    //   } else {
                    //     // 租
                    //     window.open(`${this.pub.config.pcUrl}rent-property-${sourceID}.html`,'_blank')
                    //   }
                    this.$router.push({
                        path: '/property/messages'
                    });
                } else if (res.data.code == 1200) {
                    this.$message({
                        message: '該房源已不存在',
                        type: 'error',
                        showClose: true
                    });
                }
            });
        },
        isToDateFilter(content) {
            if (!content) return false;
            if (content.indexOf('已過期') > -1 || content.indexOf('即將到期') > -1) {
                return true;
            } else {
                return false;
            }
        },
        toPropertyList(content,sourceID) {
            if (content.indexOf('已過期') > -1) {
                this.$router.push({
                    name: this.pub.routeNameLists.PropertyIndex,
                    params: {
                        due: 'over',
                        paymentstatus: 1,
                        onlyself: true
                    }
                });
            } else if (content.indexOf('即將到期') > -1) {
                this.$router.push({
                    name: this.pub.routeNameLists.PropertyIndex,
                    params: {
                        due: 'will',
                        paymentstatus: 1,
                        onlyself: true
                    }
                });
            }else{
                // 重新置顶
                 this.$router.push({
                    name: this.pub.routeNameLists.PropertyIndex,
                    params: {
                        keystring: sourceID,
                    }
                });
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/element-reset.less';
a:hover {
    cursor: pointer;
}
.yy-container {
    text-align: left;
    .w160 {
        width: 160px;
    }
    .w200 {
        width: 200px;
    }
    .el-select {
        margin-right: 50px;
        /deep/.el-input__inner {
            border-radius: 10px;
            color: #333;
            font-size: 14px;
        }
    }
    .el-button--primary {
        width: 88px;
        border-radius: 10px;
    }
    /deep/.table-wrapper {
        width: 100%;
        background-color: #fff;
        border-radius: 20px;
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        margin-bottom: 20px;
        .el-table {
            color: #222222;
            font-size: 14px;

            .el-table__row {
                td {
                    border-bottom: 1px solid #e2e2ea;
                }
                &:hover {
                    td {
                        background-color: rgba(80, 181, 255, 0.1);
                    }
                }
                a {
                    color: #0062ff;
                }
            }
        }
    }

    .el-footer {
        text-align: left;
        font-size: 13px;
        margin: 10px 0;
        padding: 0;
        .yy-record {
            display: flex;
            justify-content: flex-end;
            .yy-count {
                line-height: 48px;
                display: flex;
                div {
                    margin-right: 20px;
                    span {
                        color: #0066ff;
                    }
                }
            }
        }
        .el-pagination {
            padding: 10px 0;
        }
    }
}
</style>
